export class SpesaParcella {
  id: string;
  spesaEsente: any;
  spesaTrasferta: any;
  altraSpesaImponibile: any;
  flagSpesaGenerale: boolean;
  percSpesaGenerale: number;
}
